import { getBaseUrl } from '.';

export interface PublicInviteLinkParams {
  shareResults?: 'yes' | 'no';
  clientRelationshipStage?: string;
  customReferralSourceId?: string;
}

export function getClientOnboardingUrl(
  advisorId: string,
  params?: PublicInviteLinkParams,
): string {
  const baseUrl = getBaseUrl();
  const base = `${baseUrl}/onboard/${encodeURIComponent(advisorId)}`;
  if (!params) return base;

  const search = new URLSearchParams();
  if (params.shareResults !== undefined) {
    search.set('hasAccessToResults', params.shareResults === 'yes' ? 'true' : 'false');
  }
  if (params.clientRelationshipStage) {
    search.set('clientRelationshipStage', params.clientRelationshipStage);
  }
  if (params.customReferralSourceId) {
    search.set('customReferralSourceId', params.customReferralSourceId);
  }
  const query = search.toString();
  return query ? `${base}?${query}` : base;
}
